<script setup>
import { defineProps } from 'vue'

const props = defineProps({
    bookInfo: {
        type: Object,
        required: true
    }
})

const formatBookTitle = (title) => {
    if (title.length < 105) return title

    return title.substring(0, 105) + '...'
}

const formatBookAuthors = (authors) => {
    if (authors.length === 0) return ''
    if (authors.length === 1)
        return `${authors[0].surname} ${authors[0].name[0]}. ${authors[0].patronymic[0]}.`

    return authors.reduce((acc, author, index) => {
        if (index + 1 < authors.length)
            return (
                acc +
                `${author.surname} ${author.name[0]}. ${author.patronymic[0]}.` +
                ', '
            )
        else return acc + author
    }, '')
}
</script>

<template>
    <a
        class="book-card"
        :href="props.bookInfo.link"
        target="_blank"
    >
        <div class="image-and-filetype">
            <svg
                width="146"
                height="197"
                viewBox="0 0 146 197"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect
                    x="1"
                    y="1"
                    width="144"
                    height="195"
                    rx="7"
                    fill="white"
                    stroke="#0075AA"
                    stroke-width="2"
                />
                <rect
                    x="38"
                    y="36"
                    width="70"
                    height="6"
                    fill="#0075AA"
                />
                <rect
                    x="24"
                    y="63"
                    width="97"
                    height="3"
                    fill="#0075AA"
                />
                <rect
                    x="24"
                    y="81"
                    width="97"
                    height="3"
                    fill="#0075AA"
                />
                <rect
                    x="34"
                    y="99"
                    width="78"
                    height="3"
                    fill="#0075AA"
                />
                <rect
                    x="34"
                    y="159"
                    width="78"
                    height="3"
                    fill="#0075AA"
                />
            </svg>
        </div>
        <div class="book-title">
            {{ formatBookTitle(props.bookInfo.name) }}
        </div>
        <div class="book-authors">
            {{ formatBookAuthors(props.bookInfo.authors) }}
        </div>
    </a>
</template>

<style lang="scss" scoped>
.book-card {
    display: block;
    text-decoration: none;
    color: unset;
}

.image-and-filetype {
    position: relative;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.filetype {
    position: absolute;
    top: 0;
    left: 0;
    color: #fff;
    font-size: 10px;
    line-height: 16px;
    height: 24px;
    width: 48px;
    background: #1867c0;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.book-title {
    margin-top: 24px;
    font-size: 17px;
    line-height: 25px;
    text-align: left;
}

.book-authors {
    margin-top: 8px;
    font-size: 14px;
    line-height: 24px;
    text-align: left;
    color: rgba(30, 55, 90, 0.6);
}
</style>
